import React from "react";
import "./subPageHeader.css";
import { useNavigate } from "react-router-dom";

const SubPageHeader = ({ title, subTitle }) => {
    const navigate = useNavigate();

    const handleGetDemo = (e) => {
        e.preventDefault();
        navigate("../request-a-demo");
    };

    return (
        <div className="sub-page--heading">
            <div className="container">
                {title !== "" && (<h1>{title}</h1>)}
                {subTitle !== "" && (<p>{subTitle}</p>)}
                <button onClick={handleGetDemo} className="request-demo--btn primary">GET A DEMO</button>
            </div>
        </div>
    );
};

export default SubPageHeader;
